import React from 'react';

const Header = () => {
  return (
    <div className="header">
      <img src="./logo.webp" alt="Surfrider Foundation logo" />
      <h1>Surfrider Gironde Crew</h1>
    </div>
  );
};

export default Header;